/**
 * Socket handlers for connection lifecycle (connect, disconnect, error).
 */
import { SOCKET_EVENTS } from "../socketEvents";

export function handleConnect(_, ctx) {
  ctx.setConnected(true);
  if (typeof window !== "undefined") {
    const prev = window.__socketConnection || {};
    window.__socketConnection = {
      lastConnected: Date.now(),
      reconnects: (prev.reconnects || 0) + 1,
    };
  }
  ctx.safeRefreshFinancial?.();
  if (ctx.subscribedPropertyRef?.current && ctx.socket) {
    ctx.socket.emit(SOCKET_EVENTS.SUBSCRIBE_PROPERTY, ctx.subscribedPropertyRef.current);
  }
}

export function handleDisconnect(reason, ctx) {
  ctx.setConnected(false);
  if (reason === "io server disconnect" && ctx.socket) {
    ctx.socket.connect();
  }
}

export function handleConnectError(err, ctx) {
  ctx.setConnected(false);
  console.warn("[socket] connect_error:", err?.message);
}
